import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { itemCount } from "Constants";
import NoContent, { NO_QUIZ } from "NoContent";
import { fetchQuiz } from "CourseAction";
import {
  dynamicFormModal,
  updateFomeName,
  updateFormList,
} from "FormBuilderAction";
import AddFormBuilder from "AddFormBuilder";
import EditFormBuilder from "EditFormBuilder";
import PrintList from "./quiz-item-list";
import Pagination from "react-js-pagination";
import LocaleStrings from "Languages";

class Survey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
    };
  }

  componentDidMount() {
    this.props.fetchQuiz(this.props.session);
  }

  openModal = () => {
    var newObj = [];
    var formName = "Quiz Form";
    var fixedObj = [];

    this.props.dynamicFormModal({
      key: "add",
      showModal: true,
      category: "quiz",
      fixedFields: fixedObj,
    });
    this.props.updateFomeName(formName);
    this.props.updateFormList(newObj, [], "new");
  };

  callbackForm = () => {
    this.paginationCallback(1);
  };

  paginationCallback = (pageNumber) => {
    let { session } = this.props;

    this.props.fetchQuiz(session, pageNumber, (response) => {});

    this.setState({ ...this.state, pageNumber });
  };

  renderList() {
    let { formList } = this.props;
    let { pageNumber } = this.state;
    let pageDataLength = formList && formList.data ? formList.data.length : 0;

    return _.map(formList.data, (item, index) => {
      return (
        <PrintList
          key={`key_${index}`}
          listItem={item}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          pagination={this.paginationCallback}
        />
      );
    });
  }

  /**
   * =============================================================================================
   */

  render() {
    let { formList, formBuilderModal, deviceSize } = this.props;
    let { pageNumber } = this.state;

    return (
      <div>
        <div className="content-header-bar">
          <div className="pull-right h-100 vertical-align-center">
            <ul className="header-buttons">
              <li>
                <button
                  type="button"
                  className="btn btn-custom-blue"
                  onClick={this.openModal}
                >
                  {/* <i className="fa fa-plus i-custom-m"></i>{LocaleStrings.button_add_new} */}
                  <img
                    style={{ paddingRight: 8, paddingBottom: 3 }}
                    src="../../style/images/header-icons/plus.png"
                  ></img>
                  {LocaleStrings.button_add_new}
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div
          className="panel-body scrollable-content"
          // style={{ height: deviceSize.height - 138 }}
        >
          {formList && formList.count > 0 ? (
            <div className="sponsor-table">
              <table className="table">
                <thead>
                  <tr>
                    <th>{LocaleStrings.course_quiz_table_th_quizno}</th>
                    <th>{LocaleStrings.course_quiz_table_th_quiz_name}</th>
                    <th>{LocaleStrings.course_quiz_table_th_quiz_version}</th>
                    <th className="checkout-form-action-col-p">
                      {LocaleStrings.course_quiz_table_th_action}
                    </th>
                  </tr>
                </thead>
                <tbody className="tbody-background">{this.renderList()}</tbody>
              </table>

              {formList.count > itemCount ? (
                <Pagination
                  activePage={pageNumber}
                  itemsCountPerPage={itemCount}
                  totalItemsCount={formList.count}
                  pageRangeDisplayed={10}
                  onChange={this.paginationCallback}
                  style={{ float: "right" }}
                />
              ) : (
                ""
              )}
            </div>
          ) : (
            <NoContent contentType={NO_QUIZ} />
          )}
        </div>

        {formBuilderModal &&
        formBuilderModal.showModal &&
        formBuilderModal.key === "add" ? (
          <AddFormBuilder calledFrom={this.callbackForm} />
        ) : (
          ""
        )}

        {formBuilderModal &&
        formBuilderModal.showModal &&
        formBuilderModal.key === "edit" ? (
          <EditFormBuilder calledFrom={this.callbackForm} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
    formList: state.quizList,
    formBuilderModal: state.formBuilderModal,
  };
}

export default connect(mapStateToProps, {
  fetchQuiz,
  dynamicFormModal,
  updateFomeName,
  updateFormList,
})(Survey);
